import React from "react";
import { Link } from "react-router-dom";

export const ProductCard = ({ product }) => (
  <Link to={`/product/${product.slug}`} data-testid={`product-card-${product.slug}`}
    className="group block border border-border bg-card transition-transform duration-300 hover:-translate-y-1">
    <div className="relative aspect-[4/5] overflow-hidden bg-muted">
      <img src={product.images?.[0]} alt={product.name} loading="lazy"
        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
      {product.origin === "resale" && (
        <span className="absolute left-0 top-0 bg-white px-2 py-1 text-[10px] font-bold tracking-widest text-black">RESALE</span>
      )}
      <div className="absolute inset-x-0 bottom-0 flex translate-y-full items-center justify-center gap-2 bg-black/80 py-3 text-[10px] tracking-[0.2em] transition-transform duration-300 group-hover:translate-y-0">
        {(product.sizes || []).map((s) => <span key={s} className="text-white">{s}</span>)}
      </div>
    </div>
    <div className="flex items-center justify-between border-t border-border p-4">
      <div>
        <p className="text-sm font-medium">{product.name}</p>
        <p className="text-xs text-muted-foreground">{(product.colors || []).join(" / ")}</p>
      </div>
      <p className="font-display text-lg font-bold">${product.price}</p>
    </div>
  </Link>
);
